import QualityHubRootView from "./QualityHubRootView";

import "./QualityHubRootView.scss";

export { QualityHubRootView };
